import { NestedUser } from "@habity/types";

export const isAddedToWishlist = (user: NestedUser, homeId: number) => {
  const { interests } = user || {};
  if (!interests) return false;
  return interests.some(
    (interest) =>
      interest?.home_id === Number(homeId) &&
      interest?.interest_level === "added_to_wishlist",
  );
};
